import React from 'react';
import { Icons } from 'Assets';

interface Props {
  valid?: boolean;
}

export const IconValidity: React.FC<Props> = ({ valid }) => (
  <div data-testid="iconValidity" className="absolute top-[20px] right-[3%] pr-2">
    {valid === true ? (
      <img src={Icons.GreenCheck} alt="Invalide" height={20} width={20} />
    ) : (
      <img src={Icons.CrossRedCircle} alt="Valide" height={20} width={20} />
    )}
  </div>
);
